// Fase "Editing" del flusso contenuti: Videomaker → Editing → Programmazione.
// Predicati UNICI per la pagina Editing e per i badge altrove (Programmazione,
// Copywriter): non duplicarli nelle pagine, importarli da qui.

import { Contenuto, StatoContenuto } from '../types';
import { isPost } from './tipoContenuto';

// Fuori dal ciclo di lavorazione: usciti o chiusi.
const FUORI_LAVORAZIONE = new Set<StatoContenuto>([
  StatoContenuto.PUBBLICATO,
  StatoContenuto.ARCHIVIATO,
]);

// "Da montare": il videomaker l'ha segnato registrato, il video editor non l'ha
// ancora segnato montato, e il contenuto è ancora in lavorazione. Resta in coda
// anche se già programmato: si può programmare prima del montaggio, come si può
// programmare prima della registrazione (pulsante Programma del Videomaker).
// Le bozze sono escluse come nel Videomaker (non si registra una bozza).
export const daMontare = (c: Contenuto): boolean =>
  !isPost(c) &&
  c.videoRegistrato === true &&
  !c.videoMontato &&
  c.stato !== StatoContenuto.BOZZA &&
  !FUORI_LAVORAZIONE.has(c.stato);

// Montati nel mese: stesso criterio di reelGiratiNelMese (ripreseMatch.ts) ma
// sul flag "montato": i montati ancora in pipeline (da programmare o già
// programmati, anche per mesi futuri) più gli usciti nel mese corrente.
// Un reel girato e uscito è per forza montato, anche se nessuno ha premuto
// "Montato": succede quando l'uscita si conferma a mano dopo l'avviso di uscita
// mancata o si archivia direttamente (ottobre 2026: Moscow Mule e Americano di
// Gli Imperfetti mancavano da Editing pur essendo in Riprese).
export const reelMontatiNelMese = (
  contenutiCliente: Contenuto[],
  meseCorrente: number,
  annoCorrente: number,
): Contenuto[] =>
  contenutiCliente.filter((c) => {
    if (FUORI_LAVORAZIONE.has(c.stato)) {
      if (!c.videoMontato && !(c.videoRegistrato && !isPost(c))) return false;
      if (!c.dataPubblicazione) return false;
      const d = new Date(c.dataPubblicazione);
      return d.getMonth() === meseCorrente && d.getFullYear() === annoCorrente;
    }
    return c.videoMontato === true;
  });
